import { Model } from '@/models'

import { ProductService } from '@/services'
import { ProductStatus } from '@/enums/graphql'
import { ProductActions } from '@/enums'

export class Product extends Model {
    constructor (data) {
        super()
        Model.initializeFields(this, [
            'id',
            'name',
            'template',
            'currentInsurerConfigurationSet',
            'basicProvider',
            'status',

            // Timestamps
            'created_at',
            'updated_at',
        ], data)

        this.statusTransitions[ProductStatus.ACTIVE] = [ProductStatus.ARCHIVED]
        this.statusTransitions[ProductStatus.ARCHIVED] = [ProductStatus.ACTIVE]

        this.statusActionMapping[ProductStatus.ACTIVE] = ProductActions.UNARCHIVE
        this.statusActionMapping[ProductStatus.ARCHIVED] = ProductActions.ARCHIVE
    }

    static get service () { return ProductService }
    static status = ProductStatus
    static action = ProductActions

    static create ({ name, productTemplate, productProvider, productInsurer }) {
        return ProductService.create({ name, productTemplate, productProvider, productInsurer })
    }

    update (name) {
        return ProductService.update(this.id, name).then(product => {
            Object.assign(this, product)
            return product
        })
    }

    get actions () {
        const actions = super.actions
        actions.push({
            key: ProductActions.DELETE,
            item: this,
        })
        return actions
    }

    get providerName () {
        return this.basicProvider.display_name || this.basicProvider.name
    }

    get fullProviderName () {
        return this.basicProvider.name
    }

    get currentInsurer () {
        // This is a simplified implementation because currently only one insurer is supported.
        return this.currentInsurerConfigurationSet.configurations.at(0).insurer
    }

    get insurerName () {
        return this.currentInsurer.display_name || this.currentInsurer.name
    }

    get fullInsurerName () {
        return this.currentInsurer.name
    }

    get hasDifferentInsurer () {
        return this.basicProvider.id !== this.currentInsurer.id
    }

    archive () {
        return ProductService.changeStatus(this.id, ProductStatus.ARCHIVED).then(product => {
            this.status = product.status
            return product
        })
    }

    unarchive () {
        return ProductService.changeStatus(this.id, ProductStatus.ACTIVE).then(product => {
            this.status = product.status
            return product
        })
    }

    delete () {
        return ProductService.delete(this.id)
    }
}
